(function () {
    'use strict';

    if (window.MetodoBluAlgaecideCalculatorInitialized) return;
    window.MetodoBluAlgaecideCalculatorInitialized = true;

    var STORAGE_KEY_PREFIX = 'algaecide-calculator';

    function getNumber(value) {
        var normalized = String(value).trim().replace(',', '.');
        var parsed = parseFloat(normalized);
        return isNaN(parsed) ? null : parsed;
    }

    function formatNumber(value, decimals) {
        if (value === null || typeof value === 'undefined' || isNaN(value)) return '—';
        var fixed = value.toFixed(decimals);
        return fixed.replace(/\.0+$/, '').replace(/(\.\d*?)0+$/, '$1');
    }

    function formatMessage(template, replacements) {
        return String(template || '').replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, function (_, token) {
            return Object.prototype.hasOwnProperty.call(replacements, token) ? replacements[token] : '';
        });
    }

    function escapeHtml(value) {
        return String(value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    function decodeHtmlEntities(value) {
        if (!value) return value;
        var parser = document.createElement('textarea');
        parser.innerHTML = value;
        return parser.value;
    }

    function convertVolumeForDose(volumeM3, volumeUnit) {
        var normalizedUnit = String(volumeUnit || 'm3').toLowerCase();
        if (normalizedUnit === 'l' || normalizedUnit === 'lt' || normalizedUnit === 'liter' || normalizedUnit === 'liters' || normalizedUnit === 'litre' || normalizedUnit === 'litres') {
            return volumeM3 * 1000;
        }
        return volumeM3;
    }

    function calcVolume(state) {
        var depth = state.depth;
        if (!depth || depth <= 0) return 0;

        if (state.shape === 'rectangular') {
            if (!state.length || !state.width || state.length <= 0 || state.width <= 0) return 0;
            return state.length * state.width * depth;
        }

        if (state.shape === 'oval') {
            if (!state.length || !state.width || state.length <= 0 || state.width <= 0) return 0;
            return (Math.PI / 4) * state.length * state.width * depth;
        }

        if (state.shape === 'circular') {
            if (!state.diameter || state.diameter <= 0) return 0;
            return (Math.PI / 4) * state.diameter * state.diameter * depth;
        }

        if (state.shape === 'custom') {
            if (!state.surface || state.surface <= 0) return 0;
            return state.surface * depth;
        }

        return 0;
    }

    function createDoseResult(config, volume, template, intervalClassName) {
        if (!config || !volume) return null;
        if (!config.amount || !config.perVolume) return null;

        var volumeForDose = convertVolumeForDose(volume, config.volumeUnit);
        var dose = config.amount * (volumeForDose / config.perVolume);
        var replacements = {
            amount: '<span class="prc-result__amount">' + escapeHtml(formatNumber(dose, 2)) + '</span>',
            unit: '<span class="prc-result__unit">' + escapeHtml(config.unit || '') + '</span>'
        };

        if (config.interval) {
            replacements.interval = '<span class="' + intervalClassName + '">' + escapeHtml(config.intervalLabel || config.interval) + '</span>';
        }

        return {
            status: 'is-success',
            message: formatMessage(template, replacements),
            isHtml: true
        };
    }

    document.querySelectorAll('[data-agc-root]').forEach(function (root, rootIndex) {
        var shapeInputs = root.querySelectorAll('[data-agc-shape]');
        var inputEls = root.querySelectorAll('[data-agc-input]');
        var volumePreview = root.querySelector('[data-agc-volume-preview]');
        var volumeDisplay = root.querySelector('[data-agc-volume-display]');
        var resultsContainer = root.querySelector('[data-agc-results]');
        var storageKey = STORAGE_KEY_PREFIX + ':' + window.location.pathname + ':' + rootIndex;

        var intervalLabels = {
            daily: decodeHtmlEntities(root.getAttribute('data-agc-i18n-interval-daily')) || 'daily',
            weekly: decodeHtmlEntities(root.getAttribute('data-agc-i18n-interval-weekly')) || 'weekly',
            biweekly: decodeHtmlEntities(root.getAttribute('data-agc-i18n-interval-biweekly')) || 'every two weeks',
            monthly: decodeHtmlEntities(root.getAttribute('data-agc-i18n-interval-monthly')) || 'monthly'
        };

        var config = {
            ready: root.getAttribute('data-agc-config-ready') === 'true',
            initial: {
                enabled: root.getAttribute('data-agc-has-initial') === 'true',
                amount: getNumber(root.getAttribute('data-agc-initial-amount')) || 0,
                unit: root.getAttribute('data-agc-initial-unit') || 'g',
                perVolume: getNumber(root.getAttribute('data-agc-initial-per-volume')) || 0,
                volumeUnit: root.getAttribute('data-agc-initial-volume-unit') || 'm3'
            },
            maintenance: {
                enabled: root.getAttribute('data-agc-has-maintenance') === 'true',
                amount: getNumber(root.getAttribute('data-agc-maint-amount')) || 0,
                unit: root.getAttribute('data-agc-maint-unit') || 'g',
                perVolume: getNumber(root.getAttribute('data-agc-maint-per-volume')) || 0,
                volumeUnit: root.getAttribute('data-agc-maint-volume-unit') || 'm3',
                interval: root.getAttribute('data-agc-maint-interval') || '',
                intervalLabel: ''
            },
            unstableSeason: {
                enabled: root.getAttribute('data-agc-has-unstable-season') === 'true',
                amount: getNumber(root.getAttribute('data-agc-unstable-season-amount')) || 0,
                unit: root.getAttribute('data-agc-unstable-season-unit') || 'g',
                perVolume: getNumber(root.getAttribute('data-agc-unstable-season-per-volume')) || 0,
                volumeUnit: root.getAttribute('data-agc-unstable-season-volume-unit') || 'm3',
                interval: root.getAttribute('data-agc-unstable-season-interval') || '',
                intervalLabel: ''
            },
            afterStorm: {
                enabled: root.getAttribute('data-agc-has-after-storm') === 'true',
                amount: getNumber(root.getAttribute('data-agc-after-storm-amount')) || 0,
                unit: root.getAttribute('data-agc-after-storm-unit') || 'g',
                perVolume: getNumber(root.getAttribute('data-agc-after-storm-per-volume')) || 0,
                volumeUnit: root.getAttribute('data-agc-after-storm-volume-unit') || 'm3'
            },
            shock: {
                enabled: root.getAttribute('data-agc-has-shock') === 'true',
                amount: getNumber(root.getAttribute('data-agc-shock-amount')) || 0,
                unit: root.getAttribute('data-agc-shock-unit') || 'g',
                perVolume: getNumber(root.getAttribute('data-agc-shock-per-volume')) || 0,
                volumeUnit: root.getAttribute('data-agc-shock-volume-unit') || 'm3'
            },
            titleText: {
                initial: decodeHtmlEntities(root.getAttribute('data-agc-i18n-initial-title')) || '',
                maintenance: decodeHtmlEntities(root.getAttribute('data-agc-i18n-maintenance-title')) || '',
                unstableSeason: decodeHtmlEntities(root.getAttribute('data-agc-i18n-unstable-season-title')) || '',
                afterStorm: decodeHtmlEntities(root.getAttribute('data-agc-i18n-after-storm-title')) || '',
                shock: decodeHtmlEntities(root.getAttribute('data-agc-i18n-shock-title')) || ''
            },
            templates: {
                initial: decodeHtmlEntities(root.getAttribute('data-agc-i18n-initial-template')) || 'Add {{ amount }} {{ unit }}.',
                maintenance: decodeHtmlEntities(root.getAttribute('data-agc-i18n-maintenance-template')) || 'Add {{ amount }} {{ unit }} {{ interval }}.',
                unstableSeason: decodeHtmlEntities(root.getAttribute('data-agc-i18n-unstable-season-template')) || 'During unstable season, add {{ amount }} {{ unit }} {{ interval }}.',
                afterStorm: decodeHtmlEntities(root.getAttribute('data-agc-i18n-after-storm-template')) || 'After a storm, add {{ amount }} {{ unit }}.',
                shock: decodeHtmlEntities(root.getAttribute('data-agc-i18n-shock-template')) || 'For shock treatment, add {{ amount }} {{ unit }}.'
            }
        };

        config.maintenance.intervalLabel = intervalLabels[config.maintenance.interval] || config.maintenance.interval;
        config.unstableSeason.intervalLabel = intervalLabels[config.unstableSeason.interval] || config.unstableSeason.interval;

        var state = {
            shape: 'rectangular',
            length: null,
            width: null,
            diameter: null,
            surface: null,
            depth: 1.2,
            volume: 0
        };

        function persistState() {
            try {
                var payload = {
                    shape: state.shape,
                    length: state.length,
                    width: state.width,
                    diameter: state.diameter,
                    surface: state.surface,
                    depth: state.depth
                };
                localStorage.setItem(storageKey, JSON.stringify(payload));
            } catch (error) {
                // Ignore unavailable storage.
            }
        }

        function restoreState() {
            try {
                var raw = localStorage.getItem(storageKey);
                if (!raw) return;

                var parsed = JSON.parse(raw);
                if (!parsed || typeof parsed !== 'object') return;

                if (parsed.shape && ['rectangular', 'oval', 'circular', 'custom'].indexOf(parsed.shape) !== -1) {
                    state.shape = parsed.shape;
                    shapeInputs.forEach(function (input) {
                        input.checked = input.value === parsed.shape;
                    });
                }

                inputEls.forEach(function (input) {
                    var key = input.getAttribute('data-agc-input');
                    if (!Object.prototype.hasOwnProperty.call(parsed, key)) return;
                    var value = parsed[key];
                    if (value === null || typeof value === 'undefined' || value === '') return;
                    input.value = value;
                    state[key] = getNumber(value);
                });
            } catch (error) {
                // Ignore invalid persisted payload.
            }
        }

        function updateShapeFields() {
            root.querySelectorAll('[data-agc-shape-fields]').forEach(function (group) {
                var shapes = (group.getAttribute('data-agc-shape-fields') || '').split(' ');
                var visible = shapes.indexOf(state.shape) !== -1;
                group.classList.toggle('is-hidden', !visible);
            });
        }

        function syncVolumePreview() {
            state.volume = calcVolume(state);

            if (volumePreview) volumePreview.hidden = state.volume <= 0;
            if (volumeDisplay) {
                volumeDisplay.textContent = state.volume > 0
                    ? formatNumber(state.volume, 1) + ' m³ (' + Math.round(state.volume * 1000) + ' L)'
                    : '—';
            }
        }

        function renderResultBlock(type, titleKey, calcFn) {
            var resultEl = root.querySelector('[data-agc-result="' + type + '"]');
            if (!resultEl) return false;

            var titleEl = resultEl.querySelector('[data-agc-result-title="' + type + '"]');
            var msgEl = resultEl.querySelector('[data-agc-result-message="' + type + '"]');
            var result = calcFn();

            if (!result) {
                resultEl.hidden = true;
                return false;
            }

            resultEl.hidden = false;
            resultEl.classList.remove('is-error', 'is-warning', 'is-success');
            resultEl.classList.add(result.status);

            if (titleEl) titleEl.textContent = config.titleText[titleKey] || '';
            if (msgEl) {
                if (result.isHtml) {
                    msgEl.innerHTML = result.message;
                } else {
                    msgEl.textContent = result.message;
                }
            }

            return true;
        }

        function renderResults() {
            if (!config.ready || !state.volume || state.volume <= 0) {
                if (resultsContainer) resultsContainer.hidden = true;
                root.querySelectorAll('[data-agc-result]').forEach(function (el) { el.hidden = true; });
                return;
            }

            var anyVisible = false;

            if (renderResultBlock('initial', 'initial', function () {
                if (!config.initial.enabled) return null;
                return createDoseResult(config.initial, state.volume, config.templates.initial, 'agc-result__interval');
            })) anyVisible = true;

            if (renderResultBlock('maintenance', 'maintenance', function () {
                if (!config.maintenance.enabled) return null;
                return createDoseResult(config.maintenance, state.volume, config.templates.maintenance, 'agc-result__interval');
            })) anyVisible = true;

            if (renderResultBlock('unstable-season', 'unstableSeason', function () {
                if (!config.unstableSeason.enabled) return null;
                return createDoseResult(config.unstableSeason, state.volume, config.templates.unstableSeason, 'agc-result__interval');
            })) anyVisible = true;

            if (renderResultBlock('after-storm', 'afterStorm', function () {
                if (!config.afterStorm.enabled) return null;
                return createDoseResult(config.afterStorm, state.volume, config.templates.afterStorm, 'agc-result__interval');
            })) anyVisible = true;

            if (renderResultBlock('shock', 'shock', function () {
                if (!config.shock.enabled) return null;
                return createDoseResult(config.shock, state.volume, config.templates.shock, 'agc-result__interval');
            })) anyVisible = true;

            if (resultsContainer) resultsContainer.hidden = !anyVisible;
        }

        shapeInputs.forEach(function (input) {
            input.addEventListener('change', function () {
                state.shape = input.value;
                updateShapeFields();
                syncVolumePreview();
                renderResults();
                persistState();
            });
        });

        inputEls.forEach(function (input) {
            var key = input.getAttribute('data-agc-input');
            state[key] = getNumber(input.value);

            function handleValueChange() {
                state[key] = getNumber(input.value);

                var isInvalid = state[key] === null || state[key] <= 0;
                if (isInvalid) {
                    input.classList.add('is-invalid');
                } else {
                    input.classList.remove('is-invalid');
                }

                syncVolumePreview();
                renderResults();
                persistState();
            }

            input.addEventListener('input', handleValueChange);
            input.addEventListener('change', handleValueChange);
        });

        restoreState();

        inputEls.forEach(function (input) {
            var key = input.getAttribute('data-agc-input');
            if (state[key] !== null && typeof state[key] !== 'undefined') {
                input.value = state[key];
            }
        });

        updateShapeFields();
        syncVolumePreview();
        renderResults();
    });
})();